const lang = {
    en:{
        search:"Search",
        getSearchPlaceholder : "Confused about what to watch? Ask FILMI!"
    },
    hindi:{
        search : "खोज",
        getSearchPlaceholder : "इस बात को लेकर असमंजस में हैं कि क्या देखें? फिल्मी से पूछो!"
    },
    spanish:{
        search : "Buscar",
        getSearchPlaceholder : "¿Confundido sobre qué mirar? ¡Pregúntale a FILMI!"
    },
    marathi:{
        search : "शोधा",
        getSearchPlaceholder:"काय पहावे याबद्दल संभ्रम आहे? FILMI ला विचारा!"
    },
    japanese:{
        search : "検索",
        getSearchPlaceholder:"何を観るべきか迷っていませんか?フィルミに聞いてください！" }
}


export default lang;